import star from '../images/star.png';
import { useState } from "react"
import { useDispatch } from 'react-redux';
import { addFilter, clearFilter } from '../store/search/action';
import {fetchCard} from '../store/cards/action';
import { toggleSidebar} from '../store/sidebar/action';
import { useHistory } from 'react-router-dom';
import { debounce } from 'lodash';
import useAlert from '../hooks/useAlert';

const Search = () => {
  const [level, setLevel] = useState(0)
  const [name, setName] = useState('')
  const [atk, setAtk] = useState(-1)
  const [def, setDef] = useState(-1)

  const distpatch = useDispatch()
  const history = useHistory()
  const swal = useAlert

  const handleLevel = 
      debounce((number) => {
      setLevel(number)
    }, 1000)


  const searchCards = (e) => {
    e.preventDefault()
    let query = ''

    if (name) {
      query += `&fname=${name.split(' ').join('%20')}`
    }

    if (atk > -1) {
      query += `&atk=${atk}`
    }

    if (def > -1) {
      query += `&def=${def}`
    }

    if (level) {
      query += `&level=${level}`
    }

    if (query) {
      console.log(query);
      distpatch(addFilter(query))
      distpatch(fetchCard())
        .catch(err => {
          swal('error', 'Card Not Found') 
      })
      history.push('/')
      distpatch(toggleSidebar())
    }
    else {
      swal('error', 'Please input something to search')
    }
  }

  const clearSearch = (e) => {
    e.preventDefault()
    setLevel(0)
    setName('')
    setAtk(-1)
    setDef(-1)
    distpatch(clearFilter())
    distpatch(fetchCard())
  }

  return (
    <div
      className="
        p-2
        pt-24
        my-3
        w-full
        lg:pt-3
        text-center">
      <p
        className="
          lg:text-xl
          mb-5">Search Monster Card</p>
      <form
        className="
          text-lg">
        <div
          className="
            mb-4
            flex
            justify-center
            items-center">
          <label
            className="
              mx-2">Name </label>
          <input
            onChange={(e) => setName(e.target.value)}
            value={name}
            type="text"
            className="
              md:w-1/3
              lg:w-full
              border-2
              w-2/3
              h-8
              ml-2
              rounded
              text-gray-900
              pl-1.5"/>
        </div>
        <div
          className="
            flex
            justify-center
            items-center
            h-8
            mb-4">
          <label
            className="
              mx-2">Atk </label>
          <input
            onChange={(e) => setAtk(e.target.value)}
            value={atk === -1 ? '' : atk}
            type="number"
            min={0}
            max={5000}
            step={50}
            className="
              border-2                  
              w-16
              md:w-20              
              ml-2
              rounded
              text-gray-900
              pl-1.5"/>
          <label
            className="
              mx-2
              ml-8
              lg:ml-6">Def </label>
          <input
            onChange={ (e) => setDef(e.target.value) }
            value={def === -1 ? '' : def}
            type="number"
            min={0}
            max={5000}
            step={50}
            className="
              border-2
              w-16
              md:w-20
              ml-2
              rounded
              text-gray-900
              pl-1.5"/>
        </div>
        <div
          className="
            flex
            justify-center
            items-center
            space-x-2
            h-8
            mb-4">
          <label>Level </label>
          <input
            onChange={ (e) => handleLevel(e.target.valueAsNumber) }
            type="range"
            min="0"
            max="12"
            step="1"
            className="
              border-2
              ml-2
              rounded
              text-gray-900
              w-1/2
              md:w-1/4
              lg:w-full
              pl-1.5"/>
        </div>
        <div
          className="
            flex
            justify-center
            items-center
            space-x-2
            h-8
            mb-4"
        >
          {
            [...Array(level)].map((e, i) => {
            return <img className="h-5 mb-4" src={ star } key={i} alt="YGO Card" />
          })
          }
        </div>
        <div
          className="
            flex
            justify-center
            items-center
            space-x-4
            h-8
            mb-4">
          <button
            onClick={searchCards}
            className="
              p-1.5
              w-20
              bg-gray-200
              text-gray-900
              rounded
              hover:bg-gray-600">
            Search
          </button>
          <button
            onClick={clearSearch}
            type="reset"
            className="
              p-1.5
              w-20
              bg-gray-200
              text-gray-900
              rounded
              hover:bg-gray-600">
            Clear
          </button>
        </div>
      </form>
    </div>
  )
}

export default Search